exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".date-segment{width:calc(33.3333% - .5rem);display:inline-block;margin-left:.5rem}.date-segment--month{width:33.3333%;margin-left:0}.date-age{margin-left:.5em}.date-age:before{content:\"(\"}.date-age:after{content:\")\"}.date-age b,.date-save{color:#06a0df}.date-save{appearance:none;border:0;background:0;padding:0;font-size:.75rem;position:relative;top:-.5em;letter-spacing:.1em}.date-save:active,.date-save:focus,.date-save:hover{color:#103c63}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5f8d1018!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DatePicker.vue
// module id = 272
// module chunks = 0